import { cls } from 'tagged-classnames-free';
export const hoverBorderCls = cls`hover:border-f-border-hover border-f-border hover:text-f-text overflow-hidden rounded-[10px] border transition-colors`
